import { useTranslation } from 'react-i18next';
import { show } from '@intercom/messenger-js-sdk';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { Box, Button, Divider, Modal, Typography } from '@mui/material';

import { COLORS } from '~/styles/colors';

type SettingsMobileModalProps = {
  open?: boolean;
  setOpen?: (open: boolean) => void;
  onSettingsClick?: () => void;
  onSupportClick?: () => void;
  onDevClick?: () => void;
  onLogOutClick?: () => void;
  user?: {
    name?: string;
    email?: string;
  };
};

export default function SettingsMobileModal({
  open,
  setOpen,
  user,
  onSettingsClick,
  onLogOutClick,
}: SettingsMobileModalProps) {
  const { t } = useTranslation();
  const handleClose = () => setOpen(false);

  const onSupportClick = () => {
    show();
    handleClose();
  };

  return (
    <Modal sx={{ bottom: 0, position: 'absolute', top: 'unset' }} open={open} onClose={handleClose}>
      <Box sx={{ width: '100%', backgroundColor: COLORS.white, lineBreak: 'anywhere', pb: 2 }}>
        <Typography fontSize={14} color={COLORS.black06} sx={{ pl: 5, pr: 5, pt: 1, pb: 1 }}>
          {user.email}
        </Typography>
        <Divider />
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Button
            variant="text"
            sx={{
              justifyContent: 'flex-start',
              color: COLORS.black06,
              fontSize: 15,
              mb: 1,
              mt: 1,
              ml: 3,
              mr: 3,
            }}
            size="small"
            onClick={onSettingsClick}
            startIcon={<SettingsIcon sx={{ fill: COLORS.black, fillOpacity: 0.56 }} />}
          >
            {t('settings:settingsTitle')}
          </Button>
          <Button
            variant="text"
            sx={{
              justifyContent: 'flex-start',
              color: COLORS.black06,
              fontSize: 15,
              mb: 1,
              mt: 1,
              ml: 3,
              mr: 3,
            }}
            size="small"
            onClick={onSupportClick}
            startIcon={<SupportAgentIcon sx={{ fill: COLORS.black, fillOpacity: 0.56 }} />}
          >
            {t('buttons:supp')}
          </Button>
        </Box>
        <Divider />
        <Button
          variant="text"
          sx={{ color: COLORS.black06, fontSize: 15, mt: 1, ml: 3, mr: 3, mb: 2.5 }}
          size="small"
          onClick={onLogOutClick}
          startIcon={<LogoutIcon sx={{ fill: COLORS.black, fillOpacity: 0.56 }} />}
        >
          {t('buttons:logOutBtn')}
        </Button>
      </Box>
    </Modal>
  );
}
